package gr.tech.pdfgenerator.components.generation

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.pdfgenerator.styles.insertedFieldStyle
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY_TN
import gr.tech.pdfgenerator.util.RES
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Composable
fun MSAHeader() {
    Div(insertedFieldStyle.toModifier().width(600.px).top(10.px).left(96.px).margin(leftRight = autoLength).toAttrs()) {
        SpanText(
            "Green Rebates, L.L.C. - Master Services Agreement - ${RES.GENERAL.CURR_YEAR}",
            modifier = Modifier.fontSize(12.px).fontStyle(FontStyle.Italic).fontWeight(FontWeight.Lighter).fontFamily(FONT_FAMILY_TN)
        )
    }
}